import { useState, useEffect } from "react";
import { Sparkles, X } from "lucide-react";

const MESSAGES = [
  "Novidade: converse ao vivo por voz com a ValiosIA — não é uma gravação ✦",
  "Conformidade CFM/Anvisa embutida em cada agente ✦",
  "5 agentes geradores + 2 de onboarding já prontos ✦",
];

export default function AnnouncementBar() {
  const [visible, setVisible] = useState(true);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setIdx((i) => (i + 1) % MESSAGES.length), 5200);
    return () => clearInterval(id);
  }, []);

  if (!visible) return null;
  return (
    <div className="relative z-50 bg-[#100C0C] border-b border-brand-line" data-testid="announcement-bar">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-2 flex items-center justify-center gap-3 text-[12px] font-ui">
        <span className="callout-chip">
          <Sparkles className="w-3 h-3" /> ValiosIA
        </span>
        <span key={idx} className="text-brand-ink2 animate-fade-up">
          {MESSAGES[idx]}
        </span>
        <span className="hidden md:inline text-brand-rose underline-offset-4 hover:underline cursor-pointer">
          conheça o roadmap
        </span>
        <button
          aria-label="Fechar aviso"
          onClick={() => setVisible(false)}
          className="absolute right-4 p-1 rounded-full text-brand-ink3 hover:text-white hover:bg-white/5 transition-colors"
          data-testid="close-announcement"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
